import { NestedAutocompleteAddress } from '@habity/types';
import { getAPI } from '~/lib/api';
import { enrichAddressWithRegistry } from '~/lib/realai/residential-registry';

/**
 * Fetches and enriches an address for the sell flow
 * Handles both existing addresses (by ID) and custom addresses
 */
export async function fetchAndEnrichAddress(
  addressId?: number,
  originalStreetName?: string,
  customAddress?: NestedAutocompleteAddress
): Promise<NestedAutocompleteAddress | null> {
  try {
    let addressToUse: NestedAutocompleteAddress;

    if (customAddress) {
      // Custom address already has all the data including geocoded coordinates
      addressToUse = customAddress;
    } else if (addressId) {
      // Fetch complete address data from database
      const { data: completeAddress, error } = await getAPI(
        `/providers/supabase/addresses/autocomplete/${addressId}`
      );

      if (error || !completeAddress) {
        console.error('Error fetching complete address data:', error);
        return null;
      }

      addressToUse = completeAddress;
    } else {
      console.error('Either addressId or customAddress must be provided');
      return null;
    }

    // Enrich address with residential registry data
    const enrichedAddress = await enrichAddressWithRegistry(addressToUse);

    // Preserve the originalStreetName if it exists
    const updatedAddress = originalStreetName
      ? { ...enrichedAddress, originalStreetName }
      : enrichedAddress;

    return updatedAddress;
  } catch (error) {
    console.error('Error in fetchAndEnrichAddress:', error);
    return null;
  }
}
